/**
 * Animates an element that contains a number as inner text.
 * @param element {Element}
 * @param animationDuration {number}
 * @param value {number}
 * @param decimals {number}
 * @param locale {string}
 */
export const animate = (element, animationDuration, value, decimals, locale) => {
  const step = value / animationDuration
  let counter = 0
  const animationInterval = setInterval(() => {
    if (counter < animationDuration) {
      const currentValue = step * counter
      element.innerText = decimals ? currentValue.toLocaleString(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }) : Math.ceil(currentValue).toLocaleString(locale)
      counter++
    } else {
      element.innerText = value.toLocaleString(locale ?? 'de')
      clearInterval(animationInterval)
    }
  }, 1)
}

export const parseHighlightValueDependingOnDecimals = (highlight) => {
  let highlightValue = 0
  let decimals = 0
  if (highlight) {
    decimals = highlight.dataset.value.split('.')[1]?.trim().length || 0
    highlightValue = decimals ? parseFloat(highlight.dataset.value) : parseInt(highlight.dataset.value)
    highlight.innerText = 0
  }
  return { highlightValue, decimals }
}

export const diagramAnimationDuration = 200
export const kpiAnimationDuration = 200
